<template>
    <el-card class="course-list-container">
        <div class="course-list" v-if="activeName==='third'">
            <el-tooltip
                class="margin: 0 4px;"
                effect="dark"
                :content="$t('tooltip.export')"
                placement="bottom" >
                <div
                    @click="handleExport"
                    class="iconfont icon-fitness-daochu">
                </div>
            </el-tooltip>
        </div>
        <div class="course-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">

                <el-tab-pane
                    :label="$t('Course.fist_title')"
                    name="first"
                    v-if="$$filterPermission('课程-团课课表-团课课表查看')">
                    <group-list
                        :activeName="activeName"
                        :storeId="storeId"
                        :scheduleId.sync="scheduleId" />
                </el-tab-pane>

                <el-tab-pane
                    v-if="$$filterPermission('课程-课程设置-查看团课课程列表')"
                    :label="$t('Course.second_title')"
                    name="second">
                    <group-setting :activeName="activeName" />
                </el-tab-pane>

                <el-tab-pane
                    v-if="$$filterPermission('课程-私教预约表-仅查看上课教练是自己的')
                    || $$filterPermission('课程-私教预约表-查看全部私教预约记录')"
                    :label="$t('Course.third_title')"
                    name="third">
                    <personal-education
                        :activeName="activeName"
                        :storeId="storeId"
                        @handleForm="handleForm"
                    />
                </el-tab-pane>

                <el-tab-pane
                    v-if="$$filterPermission('课程-课程设置-查看私教课程列表')"
                    :label="$t('Course.fourth_title')"
                    name="fourth">
                    <private-lessons :activeName="activeName" />
                </el-tab-pane>

                <el-tab-pane
                    v-if="$$filterPermission('课程-教练工作时间设置-仅查看自己')
                    || $$filterPermission('课程-教练工作时间设置-可查看全部')"
                    :label="$t('Course.fifth_title')"
                    name="fifth">
                    <worktime-setting :activeName="activeName" />
                </el-tab-pane>

            </el-tabs>
        </div>
    </el-card>
</template>

<script>
import { Tabs, TabPane, DatePicker, Radio } from 'element-ui';
import FileUpload from '@/components/base/FileUpload';
import GroupList from '@/components/widget/Course/GroupList';
import PersonalEducation from '@/components/widget/Course/PersonalEducation';
import PrivateLessons from '@/components/widget/Course/PrivateLessons';
import WorktimeSetting from '@/components/widget/Course/WorktimeSetting';
import GroupSetting from '@/components/TableCom/Course/GroupSetting';

export default {
    components: {
        FileUpload,
        GroupList,
        PersonalEducation,
        PrivateLessons,
        WorktimeSetting,
        ElTabs: Tabs,
        ElRadio: Radio,
        ElTabPane: TabPane,
        ElDatePicker: DatePicker,
        GroupSetting,
    },
    mixins: [require('../../mixins/CacheQuery').default],
    data() {
        return {
            storeId: null,
            scheduleId: null,
            lessonId: null,
            form: null,
            editableTabs: [
                {
                    name: 'first',
                    isShow: this.$$filterPermission('课程-团课课表-团课课表查看'),
                }, {
                    name: 'second',
                    isShow: this.$$filterPermission('课程-课程设置-查看团课课程列表'),
                }, {
                    name: 'third',
                    isShow: this.$$filterPermission('课程-私教预约表-仅查看上课教练是自己的')
                        || this.$$filterPermission('课程-私教预约表-查看全部私教预约记录'),
                }, {
                    name: 'fourth',
                    isShow: this.$$filterPermission('课程-课程设置-查看私教课程列表'),
                }, {
                    name: 'fifth',
                    isShow: this.$$filterPermission('课程-教练工作时间设置-仅查看自己')
                        || this.$$filterPermission('课程-教练工作时间设置-可查看全部'),
                },
            ],
            filter: {},
        };
    },
    created() {
        if (this.$route.params.storeId) this.storeId = this.$route.params.storeId;
        if (this.$route.params.scheduleId) this.scheduleId = this.$route.params.scheduleId;
        if (this.$route.params.activeName) this.activeName = this.$route.params.activeName;
    },
    methods: {
        handleClick(tab, event) {},
        handleExport() {
            $ele.$confirm(this.$t('Course.index_message'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                API.post('export/coach-schedule', this.form)
                .then(res => {
                    this.$router.push({
                        name: 'Setting.List',
                        query: {
                            activeName: 'sixth',
                        },
                    });
                });
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
        handleForm(val) {
            this.form = val;
        },
    },
};
</script>

<style lang="scss">
.course-list {
    position: relative;
    -webkit-transition: -webkit-transform .3s;
    transition: -webkit-transform .3s;
    transition: transform .3s;
    transition: transform .3s, -webkit-transform .3s;
    transition: transform .3s,-webkit-transform .3s;
    float: right;
    right: 0;
    top: 0;
    z-index: 2;
    padding: 0;
    margin: 22px 0 0 10px;
    color: #697a8e;
}
.course-list-container {
    min-width: 1110px;
}
</style>
